import { useMemo, useCallback } from "react" // 추가
import Echart from "echarts-for-react"
import { langStore } from "@/stores/lang-store"
import { leakChartStore } from "./leak-chart-store"
import { leakChartBundle } from "./leak-chart-const"

const LeakChart = ({ xLabels = [], series = [] }) => {
  const { setRange, setSummary } = leakChartStore()

  const { lang } = langStore()

  const option = useMemo(() => {
    if (!xLabels.length || !series.length) return null

    return {
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          let result = `<div style="font-weight: bold margin-bottom: 4px;">${params[0].name}</div>`
          params.forEach((item, i) => {
            if (i === 2) return
            const color = i === 0 ? item.borderColor : item.value > 0 ? item.borderColor : "#999"
            const value = item.value.toLocaleString()

            result += `
              <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px;">
                <span style="display: flex; align-items: center;">
                  <span style="display:inline-block; margin-right:5px; border-radius:10px; width:10px; height:10px; background-color:${color};"></span>
                  ${item.seriesName}
                </span>
                <span style="font-weight: bold;">${value} m³</span>
              </div>
            `
          })
          return result
        }
      },
      dataZoom: [
        { type: "inside" },
        {
          show: false,
          type: "slider",
          height: 15,
          bottom: 15,
          showDetail: false,
          showDataShadow: false,
          handleSize: 40,
          handleStyle: { color: "#182a87", borderWidth: 0 },
          backgroundColor: "#f1f1f1",
          fillerColor: "#4caefe33",
          borderColor: "transparent",
          brushSelect: false,
          moveHandleSize: 0
        }
      ],
      legend: { top: 0 },
      grid: { left: "5%", right: "2%", bottom: 10, top: 50, containLabel: true },
      xAxis: {
        type: "category",
        data: xLabels.map(
          (item) => String(item).replace(/-/g, ".").slice(5) + leakChartBundle.time[lang]
        ),
        boundaryGap: false,
        axisLabel: { rotate: 0, interval: "auto", hideOverlap: true }
      },
      yAxis: { type: "value" },
      series: series.map((s) => ({
        name: leakChartBundle.info[s.name][lang],
        type: "line",
        data: s.data,
        smooth: true,
        showSymbol: false,
        symbol: "circle",
        z: s.color === "#999" ? 20 : s.color === "#ED561B" ? 10 : 5,
        itemStyle: { color: "#fff", borderColor: s.color, borderWidth: 2 },
        lineStyle: { width: 2, color: s.color },
        areaStyle: s.color === "#ED561B" ? { color: s.color, opacity: 0.08 } : null
      }))
    }
  }, [xLabels, series, lang])

  // 2. 이벤트 핸들러 메모이제이션
  const onDataZoom = useCallback(
    (params) => {
      const zoom = params.batch?.[0] || params
      const start = Math.floor((zoom.start / 100) * xLabels.length)
      const end = Math.ceil((zoom.end / 100) * xLabels.length)

      setRange(start, end, xLabels)

      const usage = series[0]?.data.slice(start, end).reduce((a, b) => a + b, 0) || 0
      const leak = series[1].data.slice(start, end).reduce((a, b) => a + b, 0) || 0

      setSummary({ usage, leak })
    },
    [xLabels, series, setRange, setSummary]
  )

  if (!xLabels.length || !series.length) return null

  return (
    <Echart
      style={{ height: "100%" }}
      option={option}
      notMerge={true} // 데이터 개수가 변하므로(2개->1개) true 권장
      onEvents={{ datazoom: onDataZoom }}
    />
  )
}

export default LeakChart
